<template>
  <div>
    <PageTitle
      title="Rate Type Details"
      :backBtn="true"
      :showLoading="isLoading"
    />
    <v-container fluid class="lighten-12">
      <v-row>
        
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="lighten-12" height="100%">
            <v-card-title>General</v-card-title>
            <v-container fluid>
              <v-row>
                <v-col cols="6" sm="6" md="6" lg="6">
                  <h4>Name</h4>
                </v-col>
                <v-col cols="2" sm="2" md="2" lg="2">
                  <v-chip label>{{ rateType.name }}</v-chip>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6" sm="6" md="6" lg="6"> <h4>Code</h4> </v-col>
                <v-col cols="6" sm="6" md="6" lg="6">
                  <v-chip label>{{ rateType.code }}</v-chip>
                </v-col>
              </v-row>
              <v-row>
              
              </v-row>
            </v-container>
          </v-card>

         
        

     

</v-col>

      </v-row>
        <v-row>
        
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="lighten-12" height="100%">
            <v-card-title>Room Type Details</v-card-title>
            <v-container fluid>
             
                <v-data-table
                        :headers="headers"
                        :items="rateType.roomTypes"
                        hide-default-footer
                        disable-pagination
                      >
                </v-data-table>
            </v-container>
          </v-card>

         
        

     

</v-col>

      </v-row>
    </v-container>
  </div>
</template>
<script>
// import RoomProperty from "./RoomProperty.vue";
import { required, email, max } from "vee-validate/dist/rules";
import { RateType } from '../../../models/RateType';
import axios from "@/plugins/axios";
export default {
  // mixins: [Categories],
  components: {
    // RoomProperty,
  },
  data: () => ({
    rateType:Object(),
         headers: [
      {
        text: "Room Type",
        value: "name",
      },
      {
        text: "Max Adult",
        value: "max_adult",
      },
        {
        text: "Max Child",
        value: "max_child",
      },
  {
        text: "Track Rate",
        value: "room_rate_type.rack_rate",
      },
      {
        text: "Extra Adult",
        value: "room_rate_type.extra_adult",
      },
      {
        text: "Extra Child",
        value: "room_rate_type.extra_child",
      },

   
    ],
  }),
  created() {
    this.GetRateTypeDetails()
  },
  methods: {
    GetRateTypeDetails()
    {
      let id=this.$route.params.id;
       axios
        .get(`hms/rate-types/${id}`)
        .then((res) => {
          this.rateType = res.data;
        });
    }
  },




};
</script>
